module.exports = __webpack_public_path__ + "img/cv.eaa89eca.svg";